import React, { useContext, useState } from 'react';

import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/react';

import { ModalRootProps } from 'components/Modal/Root';
import AuthContext from 'contexts/AuthContext';
import ClientForm from 'pages/Manage/Client/Add/Form';
import { prepareClientPayload } from 'pages/Manage/Client/Add/clientPayload';
import { api } from 'services/api';
import { isAxiosError } from 'services/axios';
import { toast } from 'shared/toast';
import { Client } from 'types/client';
import { ServiceError } from 'types/service';

const formId = 'client-add-form';

const ModalClientAdd: React.FC<ModalRootProps> = ({
  onConfirm,
  handleClose,
  ...modalProps
}) => {
  const { user } = useContext(AuthContext);
  const [saving, setSaving] = useState(false);
  const [errors, setErrors] = useState<ServiceError>({} as ServiceError);

  const submit = async (data: Client): Promise<void> => {
    if (saving) return;

    setSaving(true);
    setErrors({} as ServiceError);

    try {
      const response = await api.post('/client', {
        ...prepareClientPayload(data),
        organization_id: user.managed_organization.organization.id,
      });
      const client = (response.data.data || response.data) as Client;

      toast({
        description: 'Cliente cadastrado com sucesso!',
        status: 'success',
      });
      onConfirm?.(client);
      handleClose();
    } catch (error) {
      toast({
        description:
          (error as { response?: { data?: { message?: string } } }).response
            ?.data?.message || 'Houve um erro ao tentar cadastrar o cliente',
        status: 'error',
      });

      if (isAxiosError(error)) {
        setErrors((error.response?.data ?? {}) as ServiceError);
      }
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal
      {...modalProps}
      onClose={handleClose}
      size="5xl"
      scrollBehavior="inside"
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Criar cliente</ModalHeader>
        <ModalCloseButton />
        <ModalBody pb={2}>
          <ClientForm
            formId={formId}
            onSubmit={submit}
            saving={saving}
            serviceErrors={errors}
            showSubmitButton={false}
          />
        </ModalBody>
        <ModalFooter>
          <Button mr={3} onClick={handleClose} isDisabled={saving}>
            Cancelar
          </Button>
          <Button
            colorScheme="green"
            type="submit"
            form={formId}
            isLoading={saving}
            isDisabled={saving}
          >
            Criar cliente
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ModalClientAdd;
